import {CommonMessages} from '../common.messages';

export const PanelAccountsMessages = {
    NotFoundExportData: {
        key: 'NotFoundExportData',
        message: 'Error while communication with the server. Can\'t find data to export.'
    },
    WrongCreatedDateTo: {
        key: 'WrongCreatedDateTo',
        message: 'Created Date To must be greater than Created Date From'
    },
    WrongApprovedDateTo: {
        key: 'WrongApprovedDateTo',
        message: 'Approved Date To must be greater than Approved Date From'
    },
    WrongFeeValidDateTo: {
        key: 'WrongFeeValidDateTo',
        message: 'Valid To date be greater than Valid From'
    },
    WrongPlanBpEqAmountTo: {
        key: 'WrongPlanBpEqAmountTo',
        message: 'Plan Bp/Eq Amount To must be greater than Bp/Eq Amount From'
    },
    WrongPlanCreatedDateTo: {
        key: 'WrongPlanCreatedDateTo',
        message: 'Plan Created Date To must be greater than Plan Created Date From'
    },
    ...CommonMessages
};
